import React from 'react';
import PropTypes from 'prop-types';
import {GelPath} from '../GelPath';
import {TrashCan} from '../TrashCan';
import {GelHolder} from '../GelHolder';
import {LabelCell} from '../LabelCell';
import {CELL_TYPE} from '../GelDragDrop.constants';
import {GelDragDropContext} from '../GelDragDrop.utils';

export function LadderColumn(props) {
  const {getGridTemplateRows} = React.useContext(GelDragDropContext);

  const getClassName = (cellType) => {
    return `${props.className}__${cellType.toLowerCase()}`;
  };

  const getCellId = (cellId) => {
    return `${props.colId}_${cellId}`;
  };

  const renderCell = (cell) => {
    switch (cell.cellType) {
      case CELL_TYPE.LABEL_CELL:
        return (
          <LabelCell
            key={cell.cellId}
            className={getClassName(cell.cellType)}
            label={cell.label}
          />
        );
      case CELL_TYPE.GEL_HOLDER:
        return (
          <GelHolder
            key={cell.cellId}
            cellId={getCellId(cell.cellId)}
            className={getClassName(cell.cellType)}
            cellItems={cell.cellItems}
          />
        );
      case CELL_TYPE.GEL_PATH:
        return (
          <GelPath
            key={cell.cellId}
            cellId={getCellId(cell.cellId)}
            className={getClassName(cell.cellType)}
            cellItems={cell.cellItems}
            resultComparison={props.resultComparison}
          />
        );
      case CELL_TYPE.TRASH_CAN:
        return (
          <TrashCan
            key={cell.cellId}
            cellId={getCellId(cell.cellId)}
            className={getClassName(cell.cellType)}
            cellItems={cell.cellItems}
          />
        );
      default:
        return null;
    }
  };

  const style = getGridTemplateRows(props.colItems.length);

  return (
    <div className={props.className} style={style} aria-label={props.altText}>
      {props.colItems.map(renderCell)}
    </div>
  );
}

LadderColumn.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Unique Id for column
   */
  colId: PropTypes.number,
  /**
   * Items to render in column
   */
  colItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * UnqiueId for the cell
       */
      cellId: PropTypes.number,
      /**
       * Type of Cell
       */
      cellType: PropTypes.oneOf([
        CELL_TYPE.LABEL_CELL,
        CELL_TYPE.GEL_HOLDER,
        CELL_TYPE.GEL_PATH,
        CELL_TYPE.TRASH_CAN,
      ]),
      /**
       * Items to be rendered inside the cell
       */
      cellItems: PropTypes.arrayOf(PropTypes.object),
      /**
       * label for the cell [only for LABEL_CELL, EMPTY_GELL_HOLDER ]
       */
      label: PropTypes.string,
    })
  ),
};

LadderColumn.defaultProps = {};
